'use client';

import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@/lighting-app/compat/NextLink';
import { usePathname } from '@/lighting-app/compat/navigation';
import AppLogo from '@/lighting-app/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'الرئيسية', href: '/' },
  { label: 'صمّم إضاءة', href: '/design-new-lighting-wizard' },
  { label: 'افحص إضاءة', href: '/inspect-existing-lighting-wizard' },
];

export default function Header() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 right-0 left-0 z-50 bg-gradient-to-l from-[#111827] via-[#1f2937] to-[#f59e0b] shadow-lg">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">

          {/* Logo */}
          <RouterLink
            to="/"
            className="flex items-center gap-3 flex-shrink-0"
            aria-label="العودة إلى الصفحة الرئيسية لموقع المهندس"
          >
            <AppLogo
              src="/assets/images/logo-1787162665427.png"
              size={42}
            />

            <span className="font-cairo font-extrabold text-xl text-white hidden sm:block">
              المهندس
            </span>
          </RouterLink>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-2">
            {NAV_LINKS.map((link) => {
              const active = pathname === link.href;

              return (
                <Link
                  key={link.href}
                  href={link.href}
                  className={`px-4 py-2 rounded-lg text-sm font-bold transition-all duration-200 ${
                    active
                      ? 'bg-white/20 text-white shadow-sm'
                      : 'text-white hover:bg-white/10 hover:text-orange-200'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          {/* Desktop Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <Link
              href="/inspect-existing-lighting-wizard"
              className="px-4 py-2 rounded-xl border-2 border-white/80 text-white font-bold text-sm transition-all duration-200 hover:bg-white hover:text-[#1f2937]"
            >
              افحص إضاءة
            </Link>

            <Link
              href="/design-new-lighting-wizard"
              className="px-5 py-2 rounded-xl bg-[#f59e0b] text-white font-bold text-sm shadow-md transition-all duration-200 hover:bg-[#d97706]"
            >
              صمّم إضاءة
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-colors"
            aria-label="فتح القائمة"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-[#111827] border-t border-white/10 shadow-lg">
          <nav className="flex flex-col p-4 gap-2">

            {NAV_LINKS.map((link) => {
              const active = pathname === link.href;

              return (
                <Link
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-bold transition-all duration-200 ${
                    active
                      ? 'bg-[#f59e0b] text-white'
                      : 'text-white hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}

            <div className="grid grid-cols-2 gap-3 mt-3 pt-3 border-t border-white/10">
              <Link
                href="/inspect-existing-lighting-wizard"
                onClick={() => setMobileOpen(false)}
                className="py-3 text-center rounded-xl border-2 border-white/70 text-white font-bold text-sm hover:bg-white hover:text-[#111827] transition-all"
              >
                افحص إضاءة
              </Link>

              <Link
                href="/design-new-lighting-wizard"
                onClick={() => setMobileOpen(false)}
                className="py-3 text-center rounded-xl bg-[#f59e0b] text-white font-bold text-sm hover:bg-[#d97706] transition-all"
              >
                صمّم إضاءة
              </Link>
            </div>

          </nav>
        </div>
      )}
    </header>
  );
}